import {
  CalendarCheck,
  CalendarClock,
  CalendarX,
  Package,
  PackageCheck,
  PackageX,
} from "lucide-react";

import { type QuickFilter } from "@/components/QuickFilterCards";

const TRANSLATION_PREFIX = "home.manager.overview.farmersModal.quickFilters";

/** Ids are the backend query param names, so a selection is sent as `{ [id]: true }`. */
export type FarmerQuickFilterId =
  | "deposit_past_30"
  | "events_past_30"
  | "deposit_more_than_30"
  | "events_more_than_30"
  | "no_deposit"
  | "no_events";

/** Array order is the display order inside each card. */
export const FARMER_QUICK_FILTERS: QuickFilter<FarmerQuickFilterId>[] = [
  {
    id: "deposit_past_30",
    group: "healthy",
    icon: PackageCheck,
    iconClassName: "text-green-600 bg-green-100",
    labelKey: `${TRANSLATION_PREFIX}.withDeposits30Days`,
  },
  {
    id: "events_past_30",
    group: "healthy",
    icon: CalendarCheck,
    iconClassName: "text-green-600 bg-green-100",
    labelKey: `${TRANSLATION_PREFIX}.withEvents30Days`,
  },
  {
    id: "deposit_more_than_30",
    group: "warning",
    icon: Package,
    iconClassName: "text-brown-600 bg-brown-100",
    labelKey: `${TRANSLATION_PREFIX}.depositsOver30Days`,
  },
  {
    id: "events_more_than_30",
    group: "warning",
    icon: CalendarClock,
    iconClassName: "text-brown-600 bg-brown-100",
    labelKey: `${TRANSLATION_PREFIX}.eventsOver30Days`,
  },
  {
    id: "no_deposit",
    group: "attention",
    icon: PackageX,
    iconClassName: "text-red-600 bg-red-100",
    labelKey: `${TRANSLATION_PREFIX}.noDeposits`,
  },
  {
    id: "no_events",
    group: "attention",
    icon: CalendarX,
    iconClassName: "text-red-600 bg-red-100",
    labelKey: `${TRANSLATION_PREFIX}.noEvents`,
  },
];
